import { AlertModalController } from './alert-modal.component';

export class AlertModalService {
  constructor($timeout, $modal) {
    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  open(status, text) {
    return this.$modal.open({
      template  : require('./alert-modal.component.html'),
      controller: AlertModalController,
      resolve   : {
        errorStatus: () => status,
        errorText  : () => text,
      },
    }).result;
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/alert-modal.service.js